import {
    isPublicationCardItem,
    PublicationCardItemWithVideo,
    VideoQueueItemMeta,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React, { useEffect, useRef } from 'react'

import { metrics } from '../../../__styling'
import { CommonCardProps } from '../../../cards/CardItem.Props'
import {
    applyContainerRatio,
    ResponsiveContainer,
} from '../../../content/Picture/responsive'
import { UpNextArrow } from './assets/UpNextArrow'
import { calculateDuration } from './helpers/calculateDuration'
import {
    StyledUpNextCopy,
    StyledVideoCard,
    StyledVideoCardMedia,
    StyledVideoCardMediaWrapper,
    StyledVideoCardText,
    StyledVideoCardTextWrapper,
    StyledVideoLength,
} from './VideoCard.styled'

export interface VideoCardProps extends CommonCardProps, ResponsiveContainer {
    displayUpNextCopy: boolean
    item: MaybeLoaded<PublicationCardItemWithVideo>
    itemMeta: VideoQueueItemMeta
    handleCarouselSelection: (offsetTop?: number) => void
    handleSwipperSelection: () => void
    onSelect: (item: VideoQueueItemMeta) => void
    setNextVideo: () => void
    index: number
}

export const VideoCard: React.FC<VideoCardProps> = ({
    containerWidthRatios,
    onEvent,
    displayUpNextCopy,
    item,
    handleCarouselSelection,
    handleSwipperSelection,
    onSelect,
    itemMeta,
    setNextVideo,
    index,
}) => {
    const cardRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        if (displayUpNextCopy) {
            handleCarouselSelection(cardRef.current?.offsetTop)
            handleSwipperSelection()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayUpNextCopy])

    if (item.loaded && isPublicationCardItem(item.result)) {
        const handleClick = () => {
            onSelect(itemMeta)
            handleCarouselSelection(cardRef.current?.offsetTop)
            setNextVideo()
        }
        const handleKeyDown = (event: any) => {
            if (event.key === 'Enter') {
                onSelect(itemMeta)
                handleCarouselSelection(cardRef.current?.offsetTop)
            }
        }

        return (
            <StyledVideoCard
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                ref={cardRef}
                tabIndex={index}
            >
                <StyledVideoCardMediaWrapper>
                    <StyledVideoCardMedia
                        item={{
                            loaded: true,
                            result: item.result,
                        }}
                        onEvent={onEvent}
                        imageWidths={applyContainerRatio(containerWidthRatios, {
                            mobile: '100vw',
                            tablet: '100vw',
                            desktop: `${metrics.sevennews.siteMetrics.mainContentWidth}px`,
                            fallbackWidth:
                                metrics.sevennews.siteMetrics.mainContentWidth,
                        })}
                        fixedRatio={'16:9'}
                    />
                    <StyledVideoLength>
                        {calculateDuration(item.result.video.duration)}
                    </StyledVideoLength>
                    {displayUpNextCopy && (
                        <StyledUpNextCopy>
                            <UpNextArrow />
                            <span>Up Next</span>
                        </StyledUpNextCopy>
                    )}
                </StyledVideoCardMediaWrapper>
                <StyledVideoCardTextWrapper>
                    <StyledVideoCardText
                        item={{
                            loaded: true,
                            result: item.result,
                        }}
                        onEvent={onEvent}
                        teaserMode={'hidden'}
                        fontScale={1}
                        kickerMode={'hidden'}
                        headlineAsDiv={true}
                    />
                </StyledVideoCardTextWrapper>
            </StyledVideoCard>
        )
    }
    return null
}
